/**
 * Action creator for the allowed-resources multi-select picker used
 * in AccountEdit's Features section. The response includes Spanish
 * duplicates suffixed with `_spanish`; the consumer is expected to
 * filter those out before feeding them into Formik (legacy parity).
 *
 * Endpoint: GET /resources
 */
export const fetchResourcesAction = () => ({
  method: 'GET',
  endpoint: '/resources',
});
